// 组件对象，大写
import storageCondition from './storageCondition.vue'
export default storageCondition
